import script from "./AbitEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbitEditor.vue?vue&type=script&lang=ts&setup=true"

import "./AbitEditor.vue?vue&type=style&index=0&id=f7b7db00&lang=scss"

const __exports__ = script;

export default __exports__